/* global axios */
import ApiClient from './ApiClient';

class ConversationTranslationSettingsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  get(conversationId) {
    return axios.get(`${this.url}/${conversationId}/translation_settings`);
  }

  update(conversationId, translationSettings) {
    return axios.patch(`${this.url}/${conversationId}/translation_settings`, {
      translation_settings: translationSettings,
    });
  }
}

export default new ConversationTranslationSettingsAPI();
